module.exports = __webpack_public_path__ + "img/pantalla-4-2.7906839a.png";